import { defineCopy } from '../pageCopy';

/**
 * Strings shared by the three product detail pages (DilaCRM, DilaERP,
 * dila.menu): breadcrumb, cursor labels, cross-sell taglines, demo eyebrow.
 */
const en = {
  breadcrumbProducts: 'Products',
  bookDemo: 'Book a demo',
  cursorGo: 'Go',
  cursorOpen: 'Open',
  cursorView: 'View',
  otherProductsAria: 'Other products',
  liveLabel: 'Live',
  taglines: {
    dilacrm: 'The AI inbox that answers before your competitor wakes up.',
    dilaerp: 'The ERP that speaks Kurdish.',
    dilamenu: 'Digital menus, beautifully served.',
  },
};

type Copy = typeof en;

const ar: Copy = {
  breadcrumbProducts: 'منتجاتنا',
  bookDemo: 'احجز عرضاً تجريبياً',
  cursorGo: 'اذهب',
  cursorOpen: 'افتح',
  cursorView: 'شوف',
  otherProductsAria: 'منتجات ثانية',
  liveLabel: 'مباشر',
  taglines: {
    dilacrm: 'صندوق الرسائل الذكي اللي يرد قبل لا يصحى منافسك.',
    dilaerp: 'نظام ERP اللي يحچي كوردي.',
    dilamenu: 'منيو رقمي، يتقدم بأناقة.',
  },
};

const ckb: Copy = {
  breadcrumbProducts: 'بەرهەمەکان',
  bookDemo: 'داوای دیمۆ بکە',
  cursorGo: 'بڕۆ',
  cursorOpen: 'بیکەرەوە',
  cursorView: 'بینین',
  otherProductsAria: 'بەرهەمەکانی تر',
  liveLabel: 'زیندوو',
  taglines: {
    dilacrm: 'ئینبۆکسی زیرەک کە پێش ئەوەی ڕکابەرەکەت هەڵبستێت وەڵام دەداتەوە.',
    dilaerp: 'سیستەمی ERP کە بە کوردی قسە دەکات.',
    dilamenu: 'مینیوی دیجیتاڵ، بە جوانی پێشکەشکراو.',
  },
};

export const productsCommonCopy = defineCopy(en, ar, ckb);
